// @flow
import { plural, t } from '@lingui/macro';
import type { Untranslated } from '../types';

export const SERVICE_TYPE_CHOICES = {
  boarding: 'overnight-boarding',
  traveling: 'overnight-traveling',
  dropIn: 'drop-in',
  dayCare: 'doggy-day-care',
  walking: 'dog-walking',
  onDemandWalking: 'on-demand-dog-walking',
  assignmentGrooming: 'on-demand-grooming',
  assignmentDropIn: 'on-demand-drop-in',
};

// model after SERVICE_TYPE_PRICE_UNITS or ALTERNATIVE_RATE_UNIT
export const ALTERNATIVE_RATE_UNITS = {
  night: (count: number): Untranslated => plural({ value: count, one: 'night', other: 'nights' }),
  day: (count: number): Untranslated => plural({ value: count, one: 'day', other: 'days' }),
  visit: (count: number): Untranslated => plural({ value: count, one: 'visit', other: 'visits' }),
  walk: (count: number): Untranslated => plural({ value: count, one: 'walk', other: 'walks' }),
  groom: (count: number): Untranslated => plural({ value: count, one: 'groom', other: 'grooms' }),
};

// model after UNIT_CHOICES which is used in AddOnType.unit
export const ADD_ON_TYPE_UNITS = {
  night: (count: number): Untranslated => plural({ value: count, one: 'night', other: 'nights' }),
  bath: (count: number): Untranslated => plural({ value: count, one: 'groom', other: 'grooms' }),
  walk: (count: number): Untranslated => plural({ value: count, one: 'walk', other: 'walks' }),
  round_trip: (count: number): Untranslated =>
    plural({ value: count, one: 'round trip', other: 'round trips' }),
  session: (count: number): Untranslated =>
    plural({ value: count, one: 'session', other: 'sessions' }),
};

// all possible unit values returned by service.add_on.unit. See services.models.ServiceAddOnMixin#get_rate_unit in backend
export const SERVICE_ADD_ON_UNITS = {
  ...ALTERNATIVE_RATE_UNITS,
  ...ADD_ON_TYPE_UNITS,
};

// SERVICE_TYPE_ALTERNATIVE_RATE_UNIT, model after SERVICE_TYPE_PRICE_UNITS
export const SERVICE_TYPE_PRICE_UNITS = {
  [SERVICE_TYPE_CHOICES.boarding]: ALTERNATIVE_RATE_UNITS.night,
  [SERVICE_TYPE_CHOICES.traveling]: ALTERNATIVE_RATE_UNITS.night,
  [SERVICE_TYPE_CHOICES.dayCare]: ALTERNATIVE_RATE_UNITS.day,
  [SERVICE_TYPE_CHOICES.dropIn]: ALTERNATIVE_RATE_UNITS.visit,
  [SERVICE_TYPE_CHOICES.walking]: ALTERNATIVE_RATE_UNITS.walk,
  [SERVICE_TYPE_CHOICES.onDemandWalking]: ALTERNATIVE_RATE_UNITS.walk,
  [SERVICE_TYPE_CHOICES.assignmentGrooming]: ALTERNATIVE_RATE_UNITS.groom,
  [SERVICE_TYPE_CHOICES.assignmentDropIn]: ALTERNATIVE_RATE_UNITS.visit,
};

// model after src/aplaceforrover/services/models.py:121 FREQUENCY_CHOICES + PRICE_UNITS
export const ADD_ON_FREQUENCY = {
  ...ALTERNATIVE_RATE_UNITS,
  night: (count: number): Untranslated => plural({ value: count, one: 'night', other: 'nights' }),
  event: (count: number): Untranslated => plural({ value: count, one: 'time', other: 'times' }),
  one_time_event: () => t`time`,
};



// WEBPACK FOOTER //
// ../shared/js/constants/service.js